import { detect } from "detect-browser";

function isEmptyImage(element: HTMLElement) {
	return element.nodeName && element.nodeName.toLowerCase() === "img" && (element as HTMLImageElement).src === "" && (element as HTMLImageElement).srcset === "";
}

export function htmlToImage(opts: {
	element?: HTMLElement,
	canvas?: boolean,
} = {}) {
	const options = {
		element: document.getElementById("mapycz"),
		canvas: false,
		...opts,
	};

	return new Promise((resolve, reject) => {
		import(/* webpackChunkName: "htmlToImage" */ "html-to-image").then(HTI => {
			const browser = detect();
			const toCanvas = () => HTI.toCanvas(options.element, {
				filter: (element: HTMLElement) => !element.classList?.contains("content-news") && !isEmptyImage(element),
			});

			toCanvas().then(result => {
				// --- pro TEST
				/*const img = new Image();

				if (options.canvas) {
					result.style.position = "absolute";
					result.style.top = "0";
					result.style.left = "0";
					result.style.zIndex = "100";
					document.body.appendChild(result);
				} else {
					data = result.toDataURL();
					img.src = data;
					img.style.position = "absolute";
					img.style.top = "0";
					img.style.left = "0";
					img.style.zIndex = "100";
					document.body.appendChild(img);
				}*/
				// --- pro TEST

				if (browser.name === "safari") {
					toCanvas().then(resultSafari => {
						resolve(options.canvas ? resultSafari : resultSafari.toDataURL());
					});
				} else {
					resolve(options.canvas ? result : result.toDataURL());
				}
			}).catch(error => {
				// eslint-disable-next-line no-console
				console.error("Nastala chyba behem renderovani obrazku!", error);

				reject();
			});
		}, error => {
			// eslint-disable-next-line no-console
			console.error("Nastala chyba behem renderovani obrazku!", error);

			reject();
		});
	});
}
